import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import AnalysisFlowchart from 'analysis-tool/flowchart/AnalysisFlowchart';
import {AnalysisFlowchartMode} from 'analysis-tool/flowchart/AnalysisFlowchartContext';
import OutputPreview, {OutputPreviewProps} from 'analysis-tool/outputs/OutputPreview';
import {AnalysisOutput} from 'analysis-tool/outputs/Types';
import {NoPreviewPlaceholder} from 'analysis-tool/ui/view-templates/StepConfigurationViewTemplate';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';
import {FONT_PROXIMA_12} from 'styles/FontConstants';
import * as Colors from 'ui-library/Colors';
import {Tab, TabContainer} from 'ui-library/TabContainer';

export interface CreateAnalysisTemplatePreviewProps extends OutputPreviewProps {
  pipeline: PipelineGraphQL;
  outputs: Array<AnalysisOutput>;
}

const CREATE_ANALYSIS_TEMPLATE_FLOWCHART = 'CREATE_ANALYSIS_TEMPLATE_FLOWCHART';
const CREATE_ANALYSIS_TEMPLATE_OUTPUT_PREVIEW = 'CREATE_ANALYSIS_TEMPLATE_OUTPUT_PREVIEW';

export default function CreateAnalysisTemplatePreview(
  props: CreateAnalysisTemplatePreviewProps
): JSX.Element {
  const [currentTab, onCurrentTabChange] = useState<string>(CREATE_ANALYSIS_TEMPLATE_OUTPUT_PREVIEW);

  return (
    <TabContainer
      className={css(styles.tabContainer)}
      activeTab={currentTab}
      navClassName={css(styles.nav)}
      paneClassName={css(styles.pane)}
      onRequestTabChange={onCurrentTabChange}
    >
      <Tab tabKey={CREATE_ANALYSIS_TEMPLATE_OUTPUT_PREVIEW} title="OUTPUT PREVIEW">
        {props.outputs.length === 0 && (
          <NoPreviewPlaceholder
            title="No output preview available"
            subtitle="Optionally select items to export."
          />
        )}
        {props.outputs.length > 0 && <OutputPreview {...props} useAnalysisNamePlaceholder={true} />}
      </Tab>
      <Tab tabKey={CREATE_ANALYSIS_TEMPLATE_FLOWCHART} title="FLOWCHART ">
        <AnalysisFlowchart analysis={props.pipeline} mode={AnalysisFlowchartMode.STATIC} />
      </Tab>
    </TabContainer>
  );
}

const styles = StyleSheet.create({
  tabContainer: {height: '100%', display: 'flex', flexDirection: 'column', overflow: 'scroll'},
  nav: {
    top: '50px',
    paddingBottom: '0px',
    backgroundColor: `${Colors.WHITE}`,
    height: '36px',
    marginBottom: '0px',
    padding: '10px 12px 6px 14px',
    borderLeft: '1px solid #e0e0e0',
    ...FONT_PROXIMA_12,
  },
  pane: {flexGrow: 1, marginTop: 0},
});
